export default __webpack_public_path__ + "static/media/psychology-icon.99961faa.svg";